<template>
  <div class="bcsv-card">
    <div class="bcsv-group-head">
      <div
        class="d-flex align-center flex-wrap"
        style="gap: 10px;">
        <strong style="font-size: 15px; font-weight: 700;">{{ groupName }}</strong>
        <span
          v-if="referenceCode"
          class="bcsv-ref-chip bcsv-mono">
          {{ referenceCode }}
        </span>
      </div>
      <div
        class="d-flex align-center flex-wrap"
        style="gap: 14px;">
        <span style="font-size: 12px; color: #9AA3AE;">{{ summary }}</span>
        <button
          type="button"
          class="bcsv-btn bcsv-btn--ghost bcsv-btn--sm"
          @click="$emit('download')">
          <svg
            width="13"
            height="13"
            viewBox="0 0 14 14"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5">
            <path d="M7 2v7M4 6.5 7 9.5l3-3M2 12h10" />
          </svg>
          Download CSV
        </button>
      </div>
    </div>

    <div class="bcsv-scroll">
      <div style="min-width: 900px;">
        <div class="bcsv-grid-head bcsv-group-grid">
          <div>#</div>
          <div>sku</div>
          <div>to warehouse</div>
          <div style="text-align: right;">
            qty
          </div>
          <div>Withdraw Note</div>
          <div>Reference</div>
        </div>

        <div
          v-for="row in decoratedRows"
          :key="row.n"
          class="bcsv-group-row bcsv-group-grid"
          :style="row.tintStyle">
          <div class="bcsv-num bcsv-mono">
            {{ row.n }}
          </div>
          <div class="bcsv-cell bcsv-mono">
            {{ row.sku }}
          </div>
          <div class="bcsv-cell bcsv-mono">
            {{ row.toWarehouse }}
          </div>
          <div class="bcsv-qty bcsv-mono">
            {{ row.qty }}
          </div>
          <div style="white-space: nowrap;">
            <template v-if="row.withdrawNoteCode">
              <a
                class="bcsv-link bcsv-mono"
                @click="openWithdrawNote(row)">{{ row.withdrawNoteCode }}</a>
              <span
                class="bcsv-withdraw-note-status bcsv-mono"
                :style="{ color: rowWithdrawNoteStatusColor(row.withdrawNoteStatus) }">
                {{ rowWithdrawNoteStatusLabel(row.withdrawNoteStatus) }}
              </span>
            </template>
            <span
              v-else
              class="bcsv-ref bcsv-mono">—</span>
          </div>
          <div class="bcsv-ref bcsv-mono">
            {{ row.ref || '—' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  rowWithdrawNoteStatusLabel,
  rowWithdrawNoteStatusColor,
  rowTintStyle,
  ROW_ERROR_BG
} from '@/assets/js/BatchTransferStatusUtils'

export default {
  name: 'BatchTransferGroupTable',
  props: {
    groupName: {
      type: String,
      required: true
    },
    referenceCode: {
      type: String,
      default: ''
    },
    rows: {
      type: Array,
      default: () => []
    },
    failed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    withdrawNoteCodes () {
      const seen = []
      this.rows.forEach((row) => {
        if (row.withdrawNoteCode && seen.indexOf(row.withdrawNoteCode) === -1) seen.push(row.withdrawNoteCode)
      })
      return seen
    },
    summary () {
      const qty = this.rows.reduce((sum, row) => sum + (row.qty || 0), 0)
      const base = `${this.rows.length} แถว · ${qty} ชิ้น`
      return this.withdrawNoteCodes.length ? `${base} · ${this.withdrawNoteCodes.length} Withdraw Note` : base
    },
    decoratedRows () {
      return this.rows.map((row) => ({
        ...row,
        tintStyle: this.tintFor(row)
      }))
    }
  },
  methods: {
    rowWithdrawNoteStatusLabel,
    rowWithdrawNoteStatusColor,
    openWithdrawNote (row) {
      const routeData = this.$router.resolve({
        name: 'WithdrawNote',
        query: { id: row.withdrawNoteId, warehouse: row.toWarehouseId }
      })
      window.open(routeData.href, '_blank')
    },
    // failed → ไฮไลต์เฉพาะแถวที่ผิด, success → ไล่สีตามลำดับที่ Withdraw Note ปรากฏในกลุ่ม (FR-5.17 / FR-5.18)
    tintFor (row) {
      if (this.failed) {
        return row.error ? { background: ROW_ERROR_BG } : {}
      }
      if (!row.withdrawNoteCode) return {}
      return rowTintStyle(this.withdrawNoteCodes.indexOf(row.withdrawNoteCode))
    }
  }
}
</script>
